  console.log("kris script ");

// unhide discount progress bar when clickign add to cart

document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(".product-form__submit");
  const p_bar = document.querySelector(".apex-app.app-embed");

  if (addToCartButton) {
    addToCartButton.addEventListener("click", (event) => {
      // Your custom code here
      console.log("Add to Cart button clicked");
      if (p_bar) p_bar.style.display = "block";
    });
  }
});

//hide and unhide discount progress bar if items exists in cart

fetch("/cart.js", {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
  },
})
  .then((response) => response.json())
  .then((cart) => {
    if (cart.items.length === 0) {
      console.log("The cart is empty. ");
    } else {
      console.log("The cart has items:", cart.items);

      const p_bar = document.querySelector(".apex-app.app-embed");
      if (p_bar) {
        p_bar.style.display = "block";
      }
    }
  })
  .catch((error) => {
    console.error("Error fetching the cart:", error);
  });

//unmute and facilitate video play tap

//window.onload = function () {

document.addEventListener("DOMContentLoaded", function() {
  console.log("kris script onload");

  if (window.innerWidth >= 750) {
    //DESKTOP
    console.log("The viewport is at least 750px wide.");

    const element_k = document.querySelector(".deferred-media__poster");

    if (element_k) {
      element_k.addEventListener("click", function () {
        console.log('element_k with class "my-class" clicked!');

        var k_video = document.querySelector("video");

        if (k_video && k_video.muted) {
          console.log("The video is muted, performing action!");
          k_video.muted = !k_video.muted;
        } else {
          console.log("The video is not muted.");
        }
      });
    } else {
      console.log('No element with class ".deferred-media__poster" found.');
    }
  } else {
    console.log("The viewport is less than 750px wide.");

    const element_k_mobile = document.querySelector(
      ".product__media-toggle.quick-add-hidden"
    ); //for mobile

    if (element_k_mobile) {
      element_k_mobile.addEventListener("click", function () {
        console.log("hurra clicked!");
        const element_trigger = document.querySelector(
          ".product-media-modal__content img"
        );
        element_trigger.click();

        var k_video = document.querySelector("video");

        if (k_video && k_video.muted) {
          console.log("The video is muted, performing action!");
          k_video.muted = !k_video.muted;
        } else {
          console.log("The video is not muted.");
        }
      });
    } else {
      console.log('No element with class ".deferred-media__poster" found.');
    }
  }

  // Add second BUY button for long pages

setTimeout(function() {
  const pf = document.querySelector(".product-form");
  if (!pf) return;

  const clone = pf.cloneNode(true);
  const kDesc = document.querySelector(".k_desc_section");
  const pd = document.querySelector(".product__description");

  if (kDesc) {
    kDesc.appendChild(clone);
    console.log("added second buy button to .k_desc_section");
  } else if (pd && pd.offsetHeight > window.innerHeight * 2) {
    pd.appendChild(clone);
    console.log("added second buy button to .product__description");
  }
}, 1500);


});
